import React, { useState } from "react";
import { Link } from 'react-router-dom'
import Communication from '../../assets/images/communication.png'
import Process from '../../assets/images/process.png'
import Playbtn from '../../assets/images/play_white.svg'

function Service() {

    const [ytvideo, setytvideo] = useState(false);

    return (
        <>
            <section className="row_am service_section about_service">
                <div className="container">
                    <div className="row service_blocks">
                        <div className="col-md-6">
                            <div className="service_text" data-aos="fade-up" data-aos-duration={1500} >
                                <div className="service_badge">
                                    <i className="icofont-gear" />
                                    <span>Process</span>
                                </div>
                                <h2>
                                    <span>Overviews</span> how we develope lorem{" "}
                                </h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typtting
                                    industry lorem Ipsum has been the industrys standard dummy text ever
                                    since.
                                </p>
                                <ul className="feature_list">
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>Lorem Ipsum is simply dummy text</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>The printing and typesetting industry lorem</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>Has been the industrys dummy</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>Text ever since the when an unknown </p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="btn_block">
                                    <Link to="/contact" className="btn puprple_btn ml-0">
                                        Start Free Trial
                                    </Link>
                                    <div className="btn_bottom" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="img video_player" data-aos="fade-up" data-aos-duration={1500} >
                                <img src={Process} alt="image" />
                                <Link to="#" className="popup-youtube play-button play_icon"
                                    data-url="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1"
                                    data-toggle="modal" data-target="#myModal" title="XJj2PbenIsU" onClick={() => setytvideo(true)} >
                                    <img src={Playbtn} alt="img" />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row service_blocks flex-row-reverse">
                        <div className="col-md-6">
                            <div className="service_text right_side" data-aos="fade-up" data-aos-duration={1500} >
                                <div className="service_badge">
                                    <i className="icofont-ui-messaging" />
                                    <span>Comunication</span>
                                </div>
                                <h2>
                                    <span>Client comunication</span> for best results
                                </h2>
                                <p>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting
                                    industry lorem Ipsum has been the industrys standard dummy..
                                </p>
                                <ul className="feature_list">
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>Lorem Ipsum is simply dummy text</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>The printing and typesetting industry lorem</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            <span>
                                                <i className="icofont-check-circled" />
                                            </span>
                                        </div>
                                        <div className="text">
                                            <p>Has been the industrys dummy</p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="btn_block">
                                    <Link to="/contact" className="btn puprple_btn ml-0">
                                        Start Free Trial
                                    </Link>
                                    <div className="btn_bottom" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="img" data-aos="fade-up" data-aos-duration={1500}>
                                <img src={Communication} alt="image" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {ytvideo &&
                <div className="modal fade youtube-video show" id="myModal"
                    tabIndex={-1} style={{ display: "block", paddingRight: 17 }}
                    aria-modal="true" role="dialog" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content" onClick={() => setytvideo(false)}>
                            <button id="close-video"
                                type="button" className="button btn btn-default text-right" data-dismiss="modal" onClick={() => setytvideo(false)}>
                                <i className="icofont-close-line-circled" />
                            </button>
                            <div className="modal-body">
                                <div id="video-container" className="video-container">
                                    <iframe id="youtubevideo"
                                        width={640} height={360} allowFullScreen=""
                                        src="https://www.youtube.com/embed/tgbNymZ7vqY?autoplay=1&mute=1" />
                                </div>
                            </div>
                            <div className="modal-footer"></div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}

export default Service